import * as React from 'react'
import './StepSpacer.css'
import * as _ from 'lodash'

// import Tooltip from 'rc-tooltip';
// import 'rc-tooltip/assets/bootstrap_white.css';
import './tooltip.css'

import * as actions from "../actions"

import { DropTarget, DropTargetSpec, DropTargetConnector, DropTargetMonitor } from 'react-dnd';
import classNames from 'classnames';

import * as Model from '../types/document'
import { Cursor } from '../lib/Cursor';
import { Stack, canDragFromStackIntoStack } from 'src/types/stack';

import { NodeDrag, NewDrag, DefinitionDrag } from 'src/view/drags'
import { standardSCU } from 'src/util';
import { FixDnd } from 'src/view/DragAndDrop';
import { docAtom } from 'src/globals';
import { request } from 'http';
import { referredOrOwnNodeId } from 'src/model/nodeInfo';
// import { FixDropTarget } from 'src/view/DragAndDrop';


interface StepSpacerProps {
  index: number,
  stepsC: Cursor<Model.Steps>,
  blockC: Cursor<Model.Block>,
  stack: Stack,
  alwaysShow?: boolean,
}

const dropSpec: DropTargetSpec<StepSpacerProps> = {
  drop(props, monitor) { actions.act(() => {
    switch (monitor.getItemType()) {
      case 'node':
        const nodeDrag = monitor.getItem() as NodeDrag
        switch (nodeDrag.type) {
          case 'move-subtree': {
            const newGraphC = actions.insertStepIntoSteps(actions.makeNewGraph(), props.stepsC, props.index)
            actions.moveSubtree(nodeDrag.blockC, nodeDrag.nodeId, newGraphC)
            break }
          case 'copy-reference': {
            const newGraphC = actions.insertStepIntoSteps(actions.makeNewGraph(), props.stepsC, props.index)
            actions.addReferenceNodeToGraph(referredOrOwnNodeId(nodeDrag.blockC, nodeDrag.nodeId), newGraphC, props.blockC)
            break }
          default:
            throw new Error(`tried to drop unknown cell-type ${nodeDrag.type} on StepSpacer`)
        }
        break
      case 'new': {
        const newDrag = monitor.getItem() as NewDrag
        const { stepsC, index } = props
        switch (newDrag.type) {
          case 'node': {
            const newGraphC = actions.insertStepIntoSteps(actions.makeNewGraph(), stepsC, index)
            actions.addEmptyCodeCall(newGraphC)
            break }
          case 'text': {
            actions.insertStepIntoSteps(actions.makeNewText(), stepsC, index)
            break }
          case 'switch': {
            actions.insertStepIntoSteps(actions.makeNewSwitch(), stepsC, index)
            break }
        }
        break }
      case 'definition': {
        const definitionDrag = monitor.getItem() as DefinitionDrag
        const { stepsC, blockC, index } = props
        const newGraphC = actions.insertStepIntoSteps(actions.makeNewGraph(), stepsC, index)
        actions.addDefinitionCallWithDefaults(newGraphC, definitionDrag.definitionId)
        break }
      default:
        throw new Error(`tried to drop unknown type ${JSON.stringify(monitor.getItemType())} on StepSpacer`)
    }
  })},

  canDrop(props, monitor: DropTargetMonitor) {
    switch (monitor.getItemType()) {
      case 'node':
        const nodeDrag = monitor.getItem() as NodeDrag
        return canDragFromStackIntoStack(nodeDrag.stack, props.stack)
      case 'new':
        return true
      case 'definition':
        return true
    }
    return false
  }
}

function dropCollect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

class StepSpacer extends React.Component<StepSpacerProps & ReturnType<typeof dropCollect>> {

  state = { delayedCanDrop: false }

  render() {
    const { connectDropTarget, isOver, alwaysShow } = this.props
    const { delayedCanDrop } = this.state

    return connectDropTarget(<div
      className={classNames({
        "StepSpacer": true,
        "StepSpacer-can-drop": delayedCanDrop || alwaysShow,
        "StepSpacer-is-over": isOver
      })}
    />)
  }

  componentDidUpdate() {
    // Because StepSpacer appears and disappears, it can shift drag-sources
    // around on the page. This has the potential to move the dragging cursor
    // out of the source, which somehow breaks the drag. (Not sure how.) So we
    // delay the appearance/disappearance of StepSpacer. Somehow this works. How
    // very bananas.
    if (this.state.delayedCanDrop !== this.props.canDrop) {
      setTimeout(() => this.setState({delayedCanDrop: this.props.canDrop}), 0);
    }
  }
}

export default FixDnd(DropTarget(["node", "new", "definition"], dropSpec, dropCollect, {arePropsEqual: () => false})(StepSpacer))



// WEBPACK FOOTER //
// ./src/view/StepSpacer.tsx